<template>
  <v-dialog v-model="open" max-width="50vw" @click:outside="() => $emit('exit')">
    <v-card class="mx-auto set-layout">
      <v-card-title class="headline" style="height:10%">Action: Install Device</v-card-title>
      <v-container fluid style="height:85%">
        <v-row justify="space-between" align="center" class="fill-height">
          <v-col cols="5" class="fill-height">
            <v-autocomplete
              v-model="selectedTag"
              style="height:10%"
              label="Search"
              :items="tags"
              item-text="installation_tag"
              clearable
              return-object
              solo
            ></v-autocomplete>
            <v-card class="mx-auto pa-2 transfer-source" outlined tile>
              <v-list>
                <v-list-item-group v-model="selectedTags" :multiple="tab === 0">
                  <template v-for="tag in tags">
                    <v-list-item :key="tag.id" :value="tag" active-class="third--text">
                      <template v-slot:default="{ active, toggle }">
                        <v-list-item-content>
                          <v-list-item-title v-text="tag.install_tag"></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </template>
                </v-list-item-group>
              </v-list>
            </v-card>
          </v-col>

          <v-col cols="5" class="fill-height">
            <v-select v-show="tab === 0" v-model="selectedType" :items="vehiType" label="Vehicle Type" solo style="height:10%"></v-select>
            <v-autocomplete
              v-show="tab === 1"
              v-model="selectedVehicle"
              style="height:10%"
              label="Select Vehicle"
              :items="vehicles"
              item-text="vehicle_name"
              clearable
              return-object
              solo
            ></v-autocomplete>
            <v-card class="transfer-target mx-auto" outlined tile>
              <v-tabs v-model="tab" right icons-and-text class="fill-height">
                <v-tab>
                  Assign to group
                  <v-icon>mdi-folder</v-icon>
                </v-tab>
                <v-tab>
                  Assign to vehicle
                  <v-icon>mdi-car</v-icon>
                </v-tab>

                <v-tab-item class="fill-height">
                  <pvcam-wc-node-transfer
                    v-if="open"
                    vehicle
                    :org="org"
                    :reenter="reenter"
                    @target-node="setTarget"
                  ></pvcam-wc-node-transfer>
                </v-tab-item>

                <v-tab-item class="fill-height">
                  <v-progress-circular
                    v-if="loader"
                    :size="50"
                    color="secondary"
                    class="progress-circular-absolute"
                    indeterminate
                  ></v-progress-circular>
                  <v-list class="fill-height pa-0">
                    <v-list-item-group v-model="selectedVehicle" class="fill-height vehicle-list-scroll">
                      <template v-for="(car, j) in vehicles">
                        <v-list-item :key="'vehi' + j" :value="car" active-class="third--text">
                          <template v-slot:default="{ active, toggle }">
                            <v-list-item-icon>
                              <v-icon v-if="car.devices && car.devices.length < 1">mdi-file-outline</v-icon>
                              <v-icon v-else>mdi-car</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                              <v-list-item-title v-text="car.vehicle_name"></v-list-item-title>
                            </v-list-item-content>
                          </template>
                        </v-list-item>
                      </template>
                    </v-list-item-group>
                  </v-list>
                </v-tab-item>

              </v-tabs>
            </v-card>
          </v-col>
        </v-row>

        <v-row justify='end'>
          <v-col cols="12" class="no-padding">
            <v-card-actions>
              <v-spacer/>
              <v-dialog v-model="confirmModal" persistent max-width="600" scrollable>
                <template v-slot:activator="{ on }">
                  <v-btn v-show="tab === 1" :disabled="showAssign()" text color="third" v-on="on" @click="calcActions">
                    Confirm
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="headline">You are about to perform following actions:</v-card-title>
                  <v-card-text style="height: 40vh;">
                    <actions :actions="actions" :is-hidden="isHidden" @update:active="setVisible" />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="green darken-1" text @click="confirmModal = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="warning darken-1" text @click="submitAssign">submit</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="shortcutModal" persistent max-width="500" scrollable>
                <template v-slot:activator="{ on }">
                  <v-btn v-show="tab === 0" :disabled="showAssign()" text color="third" v-on="on" @click="calcAllActions">
                    Confirm
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="headline d-block text-center warning--text">Warning</v-card-title>
                  <v-card-text>
                    Be aware that this action will take all selected device to the target group, if none is selected the default is all / root.
                    All devices will automatically be assigned to a new created vehicle labeled with the installation tag. Bear in mind, created
                    vehicles will be automatically enabled.
                    <br />
                    <b>Are you sure you want to continue?</b>
                  </v-card-text>
                  <v-card-text style="height: 30vh;">
                    <actions :actions="actions" :is-hidden="isHidden" />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="green darken-1" text @click="shortcutModal = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="warning darken-1" text @click="fastForward">Submit</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card-actions>
          </v-col>
        </v-row>

      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue"
import { GetOrgVehicles, CreateOrgVehicle, AssignDeviceToVehicle } from "@/services/API.js"
import { Logger } from "aws-amplify"
import { mapState } from "vuex"
import Actions from "./Actions"
const logger = new Logger("Transfer")
export default {
  components: { Actions },
  props: {
    open: {
      required: true,
      type: Boolean,
    },
    org: {
      required: true,
      type: String,
    },
    task: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    tab: 0,
    tags: [],
    visible: new Set(),
    selectedTag: "",
    selectedTags: [],
    selectedVehicle: {},
    selectedType: "Car",
    targetNode: "",
    nodes: [],
    vehicles: [],
    actions: [],
    isHidden: true,
    confirmModal: false,
    shortcutModal: false,
    reenter: false,
    loader: true
  }),
  computed: {
    ...mapState(["vehiType", "orgs"])
  },
  watch: {
    tab(newVal, oldVal) {
      logger.debug("tab", newVal, oldVal)
      if (newVal !== oldVal) {
        this.selectedTags = []
      }
    },
    selectedTag(val) {
      logger.debug("selectedTag", val)
      if (val) {
        this.tab === 0 ? (this.selectedTags = [val]) : (this.selectedTags = val)
      }
    },
    selectedTags(val) {
      logger.debug("selectedTags", val)
    },
    open(val) {
      if (val) {
        this.tags = this.task.context.devices.filter((tag) => !tag.vehicle_name)
        this.getOrgVehicles(this.org)
      }
    },
  },
  mounted() {
    logger.debug("mounted")
    this.$el.addEventListener("dragenter", this.handleReEnter)
    // this.tags = Array.from(this.task.installation_tags);
  },
  destroyed() {
    this.$el.removeEventListener("dragenter", this.handleReEnter)
  },
  methods: {
    showAssign() {
      logger.debug("showAssign", this.selectedTags, this.targetNode, this.selectedVehicle)
      if (this.tab === 0) {
        if (this.targetNode && this.selectedTags.length > 0) return false
      } else if (this.tab === 1) {
        if (this.selectedVehicle && this.selectedTags && this.selectedTags.logical_id) return false
      }
      return true
    },
    setVisible(vehicles) {
      this.visible = vehicles
    },
    async submitAssign() {
      let res;

      const id = this.tags[0].logical_id;
      const vehicle_id = this.actions[0].target.id;
      const param = {
        deviceId: id
      };
      
      if (this.visible.has(id)) param.visible = true;
      res = await AssignDeviceToVehicle(this.org, vehicle_id, param);

  
      if (res) {
        this.tags = this.tags.filter((tag) => {
          const hasId = this.actions.some((act) => {
            return tag.id === act.id
          })
          return !hasId
        })
        AmplifyEventBus.$emit("snackEvent", {
          color: "success",
          text: `Changes have been made`,
        })
      }

      this.confirmModal = false
    },
    calcActions() {
      if (this.tab === 0) {
        this.isHidden = true
        this.actions = this.selectedTags.map((tag) => {
          return {
            name: tag.install_tag,
            id: tag.logical_id,
            locked: false,
            hidden: false,
            type: this.selectedType,
            target: this.targetNode,
          }
        })
        this.confirmModal = true
      } else {
        logger.debug(this.selectedVehicle, this.selectedTags)
        this.isHidden = true
        this.actions = [
          {
            name: this.selectedTags.install_tag,
            id: this.selectedTags.logical_id,
            locked: false,
            hidden: false,
            type: this.selectedType,
            target: this.selectedVehicle,
          },
        ]
        this.confirmModal = true
      }
    },
    calcAllActions() {
      this.isHidden = false
      this.actions = this.tags.map((tag) => {
        return {
          name: tag.install_tag,
          id: tag.id,
          locked: true,
          hidden: false,
          type: this.selectedType,
          target: this.targetNode,
        }
      })
      logger.debug("actions", this.actions)
    },
    setTarget(e) {
      logger.debug("target", e, e.detail[0])
      if (e.detail.length > 0 && e.detail[0]) this.targetNode = e.detail[0]
    },
    async fastForward() {
      const param = {
        org: this.org,
        nodeId: this.targetNode.id,
        vehicleType: this.selectedType,
        vehicleName: this.tags[0].context.devices
      }
      const res = await CreateOrgVehicle(this.org, param)
      this.shortcutModal = false
      if (res) {
        this.submitAssign()
      }
    },
    handleReEnter() {
      this.reenter++
    },
    async getOrgVehicles(org) {
      const res = await GetOrgVehicles(org, true)
      if (res) {
        this.vehicles = res.filter(item => item.devices.length < 1)
      }
      this.loader = false
    }
  },
}
</script>

<style lang="scss">
.transfer-source {
  height: 85%;
}
.vehicle-list-scroll {
  overflow-x: hidden;
  overflow-y: scroll;
}
.transfer-target {
  height: 90%;
  .v-tabs-items {
    height: calc(100% - 72px);
    .v-window__container {
      height: 100%;
    }
  }
}
.no-padding {
  padding: 0 0.5em !important;
  margin: 0 !important;
}

.set-layout {
  height: 85vh;
  width: 50vw;
  overflow-x: hidden;
}
</style>
